import { createGetEndpoint } from '@sonar-software/sonar-http';
import { SonarTag } from '@types';

export type GetTagsResponse = Array<SonarTag>;

export const getTags = createGetEndpoint<void, GetTagsResponse>('/api/v3/core/tags/');
